var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { TwitterLogoIcon } from '../atoms/icons/twitter_logo_icon';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles/variables';
import { SharedTiming } from '@lean-body/src/interfaces';
export const TwitterWithText = (props) => {
    const { text, twitterService, onClickTwitterShareIfAuthed, lesson, program, playlist } = props;
    const onClick = () => __awaiter(void 0, void 0, void 0, function* () {
        yield twitterService.onClickShare(SharedTiming.share_button, lesson, program, playlist);
        if (twitterService.isAuthorized)
            onClickTwitterShareIfAuthed();
    });
    return (React.createElement("div", { className: css(styles.container), onClick: onClick },
        React.createElement("div", { className: css(styles.button) },
            React.createElement(TwitterLogoIcon, { color: Colors.Twitter })),
        text && React.createElement("span", { className: css(styles.text) }, text)));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        gap: 5,
    },
    button: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colors.White,
        borderRadius: '50%',
        border: `1px solid ${Colors.BorderLightGrayB}`,
        boxShadow: `0px 15px 30px rgba(0, 180, 199, 0.08)`,
        width: 32,
        height: 32,
        padding: '1px 6px',
        [MediaBreakPointUp.MD]: {
            width: 44,
            height: 44,
        },
    },
    text: {
        fontSize: 12,
        fontWeight: 'bold',
        color: Colors.Black,
        [MediaBreakPointUp.MD]: {
            fontSize: 14,
            margin: 0,
        },
    },
});
